import { render, staticRenderFns } from "./PopupOverlay.vue?vue&type=template&id=e5837fb0&scoped=true&"
import script from "./PopupOverlay.vue?vue&type=script&lang=ts&"
export * from "./PopupOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./PopupOverlay.vue?vue&type=style&index=0&id=e5837fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5837fb0",
  null
  
)

export default component.exports